import React, { ReactNode, useState } from 'react';

import CampaignSidebarLayout from './CampaignSidebarLayout';
import { CampaignFormUnsavedChangesModal } from './modals/CampaignFormUnsavedChangesModal/CampaignFormUnsavedChangesModal';

export type CampaignFormLayoutProps = {
  children: ReactNode;
  preview: ReactNode;
  tooltip: string;
  banner?: ReactNode;
  infoBannerContent?: {
    title: string;
    text: string;
    campaignId: string;
  };
  isFloatingBannerEnabled?: boolean;
  onFormSubmit: () => void;
};

const CampaignFormLayout = ({
  children,
  preview,
  banner,
  infoBannerContent,
  isFloatingBannerEnabled,
  tooltip,
}: CampaignFormLayoutProps) => {
  const [isUnsavedChangesModalOpen, setIsUnsavedChangesModalOpen] = useState<boolean>(false);

  return (
    <CampaignSidebarLayout
      preview={preview}
      banner={banner}
      isFloatingBannerEnabled={isFloatingBannerEnabled}
      tooltip={tooltip}
      infoBannerContent={infoBannerContent}
    >
      <CampaignFormUnsavedChangesModal isOpen={isUnsavedChangesModalOpen} setIsOpen={setIsUnsavedChangesModalOpen} />
      {children}
    </CampaignSidebarLayout>
  );
};

export default CampaignFormLayout;
